import {Box} from "@mui/material";
import DetailsLoading from "crqlar-react-common/dist/components/DetailsLoading";
import {useEntity} from "crqlar-react-common/dist/components/useEntity";
import {Survey} from "crqlar-react-common/dist/models/survey/survey.model";
import {SurveyService} from "crqlar-react-common/dist/services/survey/survey.service";
import {useTrackScreenVisit} from "crqlar-react-common/dist/utils/analytics.util";
import {useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";
import SettingsEntityHeader from "../../system/layout/SettingsEntityHeader";
import {useSurveyChangeRefresh} from "../shared/surveyQueryRefresh";
import SurveyBasicInfoTab from "./SurveyBasicInfoTab";
import {blankSurveyDraft} from "./surveyDraft.util";

/** Setting a survey up. Its answers are read in the module's Evaluation tab, which the page links to. */
const SurveyDetails = () => {

    useTrackScreenVisit('system survey details')

    const {id} = useParams()
    const navigate = useNavigate()
    const refreshSurveys = useSurveyChangeRefresh()

    useEffect(() => {
        if (id === 'new') navigate('/system/surveys', {replace: true})
    }, [id, navigate])

    const surveyData = useEntity({
        get: async () => {
            if (id && id !== 'new') return SurveyService.getSurveyById(id)
            return blankSurveyDraft()
        },
        create: SurveyService.createSurvey,
        update: SurveyService.updateSurvey,
        delete: (surveyId: string) => SurveyService.deleteSurvey({id: [surveyId]}),
        onSaved: () => {
            void refreshSurveys()
        },
        onDeleted: () => {
            void refreshSurveys()
            navigate('/system/surveys', {replace: true})
        },
        isValid: (survey: Survey) => !!survey.name?.trim() && !!survey.type
    }, id)

    const survey = surveyData.item

    const updateField = (field: keyof Survey, value: any) => {
        surveyData.setItem({...survey, [field]: value})
    }

    const headerSection = (
        <SettingsEntityHeader
            title={survey.name}
            data={surveyData}
            back={() => navigate('/system/surveys')}
        />
    )

    return (
        <Box sx={{width: '100%', pb: 8}}>
            {headerSection}

            {surveyData.loading ? (
                <DetailsLoading/>
            ) : (
                <SurveyBasicInfoTab
                    surveyData={surveyData}
                    updateField={updateField}
                />
            )}
        </Box>
    )
}

export default SurveyDetails
